import { create } from 'zustand';
import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_KEY = '@teamFilter:v1';

const initialState = {
    selectedTeamID: null,
    isHydrated: false,
};

const useTeamFilterStore = create((set) => ({
    ...initialState,

    hydrate: async () => {
        try {
            const stored = await AsyncStorage.getItem(STORAGE_KEY);
            if (stored) {
                const parsed = JSON.parse(stored);
                if (parsed && (parsed.selectedTeamID === null || typeof parsed.selectedTeamID === 'string' || typeof parsed.selectedTeamID === 'number')) {
                    set({ selectedTeamID: parsed.selectedTeamID ?? null, isHydrated: true });
                    return;
                }
            }
        } catch {
            // fall back to default (All Teams)
        }
        set({ selectedTeamID: null, isHydrated: true });
    },

    // Set the selected team ID. Pass null/undefined to clear (All Teams).
    setTeamID: async (teamID) => {
        const next = teamID ?? null;
        try {
            await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify({ selectedTeamID: next }));
        } catch {
            // silently fail
        }
        set({ selectedTeamID: next });
    },

    clear: async () => {
        try {
            await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify({ selectedTeamID: null }));
        } catch {
            // silently fail
        }
        set({ selectedTeamID: null });
    },
}));

export default useTeamFilterStore;
